﻿import { AuthProvider, AuthProviderProps, UserManager } from "oidc-react";
import { getSettings } from "../common/settingsProvider";
import { setJwtToken } from "../common/api/apiShared";
import { getPdfToken } from "../common/pdfUrlHelper.ts";
import { useNavigate } from "react-router";
import { isValidInternalPath } from "./internalPath.ts";

export interface IPrivacyAuthProviderProps {
    children: JSX.Element;
}

let settings = getSettings();

const pdfToken = getPdfToken();

export const userManager = new UserManager({
    authority: settings.idpAuthority,
    client_id: settings.idpClientId,
    response_type: "code",
    redirect_uri: settings.mainSiteBaseUrl + "/privacy/sign-in-callback",
    post_logout_redirect_uri: settings.mainSiteBaseUrl,
    automaticSilentRenew: true,
    scope: "openid profile offline_access role",
});

if (pdfToken) {
    setJwtToken(pdfToken);
}

function PrivacyAuthProvider(props: IPrivacyAuthProviderProps) {
    const navigate = useNavigate();

    const oidcConfig: AuthProviderProps = {
        onBeforeSignIn: () => {
            sessionStorage.setItem("location-before-sign-in", window.location.pathname + window.location.search + window.location.hash);
            return "";
        },
        onSignIn: () => {
            let locationBeforeSignIn = sessionStorage.getItem("location-before-sign-in") ?? "/";

            if (!isValidInternalPath(locationBeforeSignIn)) {
                locationBeforeSignIn = "/";
            }
            navigate(locationBeforeSignIn);
        },
        userManager: userManager,
        autoSignIn: pdfToken === null,
    };

    return <AuthProvider {...oidcConfig}>{props.children}</AuthProvider>;
}

export default PrivacyAuthProvider;
